export default __webpack_public_path__ + "static/media/eastwest_logo.675576c1.png";